import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { withApollo } from 'react-apollo';
import { withRouter, Link } from 'react-router-dom';
import { withAuth } from '@cdk-prod/fortellis-auth-context';
import { withEntityContext } from '@cdk-prod/fortellis-entity-context';
import { Header } from '@fortellis/header';
import config from './config';
import './header.scss';
import { LocaleConsumer } from '@fortellis/locale/dist/LocaleContext';

const CASE_MANAGEMENT_NAV_ITEM = 'case-management';

function AuthHeader({
  auth,
  entityContext,
  localeContext,
  location,
  mobile,
  onPermissionReception,
  onAuthenticated,
  ...props
}) {
  const { entities, entitiesIndex, entitiesLoaded } = entityContext;
  const [userPermissionsReceived, setUserPermissionsReceived] = useState(false);
  const [isAuthenticated, setAuthentication] = useState(false);
  // const classes = classnames({
  //   'frc-header--cover': location.pathname === '/'
  // });

  //called when component will update or mount
  useEffect(() => {
    if (!isAuthenticated && auth.isAuthenticated) {
      setAuthentication(true);
      onAuthenticated(true);
    }
  });

  async function fetchUserPermissions(email) {
    const queryResponse = await props.client.query({
      query: gql`
        query($developerEmail: String) {
          userPermissions(developerEmail: $developerEmail) {
            permissions
          }
        }
      `,
      variables: { developerEmail: email }
    });

    if (queryResponse && queryResponse.data) {
      setUserPermissionsReceived(true);
      onPermissionReception(
        queryResponse.data.userPermissions.permissions,
        entities[entitiesIndex]
      );
    } else {
      setUserPermissionsReceived(false);
      onPermissionReception([], '');
    }
  }
  if (entitiesLoaded)
    if (auth.isAuthenticated && auth.userData && !userPermissionsReceived) {
      fetchUserPermissions(auth.userData.email);
    }

  // Filter menu items based on organization
  const getFilteredNav = () => {
    const nav = { ...config.nav };
    if (process.env.REACT_APP_NAV_CASE_MANAGEMENT_ENABLED !== 'true') {
      return nav; // Case management not enabled, return original nav
    }
    const currentOrgId = entityContext?.entity?.id;
    const whitelistedOrgs =
      process.env.REACT_APP_CASE_MANAGEMENT_WHITELISTED_ORGS || '';
    const whitelistedOrgIds = whitelistedOrgs.split(',').map(id => id.trim());
    const shouldShowCaseManagement =
      auth.isAuthenticated &&
      currentOrgId &&
      whitelistedOrgIds.length > 0 &&
      whitelistedOrgIds.includes(currentOrgId);

    // Filter out case management if user is not in whitelisted org
    if (!shouldShowCaseManagement && nav.user && nav.user.menu) {
      nav.user = {
        ...nav.user,
        menu: nav.user.menu.filter(
          item => item.code !== CASE_MANAGEMENT_NAV_ITEM
        )
      };
    }

    return nav;
  };

  return (
    <LocaleConsumer>
      {localeContext => (
        <Header
          // className={classes}
          mobile={mobile}
          authenticated={auth.isAuthenticated}
          entityContext={entityContext}
          localeContext={localeContext}
          login={auth.login}
          logout={auth.logout}
          nav={getFilteredNav()}
          routerLink={Link}
          selectedKey="marketplace"
          signup={config.signup.url}
          user={auth.userData}
        />
      )}
    </LocaleConsumer>
  );
}

AuthHeader.propTypes = {
  auth: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired
};

export default withRouter(withApollo(withAuth(withEntityContext(AuthHeader))));
